const rgd_colors = {
  primary: '#FA4022', 
  primaryOpacity: '#FA40228C',

  backgroundComponent: '#F6F6F6',
  backgroundPage: '#FFFFFF',
  backgroundInput: '#D3D5D7',
  backgroundPromotionStatus: '#CCF4D7',
  backgroundPromotionData: '#EDF8FF',

  text1: '#000000',
  text2: '#737373',
  textDataUpdated: '#647893',
  textPromotionStatus: '#01A72F',
  textPromotionData: '#CCF4D7',
  textPastEntryCard: '#9B9B9B',

  logoName: '#414141',
  
  cardBorder: '#EBEBEB',
  actionLog: '#FFD700',
  inputBorder: '#F6F6F6',
  greetBorder: '#E7F0F5',

  // Promotions
  greenCard: '#CCF4D7',
  greenText: '#01A72F',
  blueCard: '#EDF8FF',
  blueText: '#1472FF',

  // Для силы пароля (индикатор)
  brightGreenPower: '#00FF00',
  greenPower: '#2E7D32',
  amberPower: '#FFB300',
  orangePower: '#F57C00',
  redPower: '#C62828'
}

export default rgd_colors;